/* DEPRECATED
   use graphQL instead
*/
import { AxiosInstance } from 'axios'
import { IWorkspace } from '../../../types/Workspace'

// TODO: check if this file is still used convert it to graphQL and remove if not.

export default (axios: AxiosInstance) => {
  return {
    update(
      workspaceId: number,
      data: Partial<IWorkspace>
    ): Promise<IWorkspace> {
      return axios
        .patch<IWorkspace>(`/workspaces/${workspaceId}`, data)
        .then((res) => res.data)
    },

    uploadCoverImage(
      workspaceId: number,
      image: File
    ): Promise<{ msg: string }> {
      const formData = new FormData()
      formData.append('image', image)
      return axios
        .post<{ msg: string }>(
          `/workspaces/${workspaceId}/cover-image`,
          formData
        )
        .then(({ data }) => data)
    },
    removeCoverImage(workspaceId: number) {
      return axios
        .delete<{ msg: string }>(`/workspaces/${workspaceId}/cover-image`)
        .then(({ data }) => data)
    }
  }
}
